module.exports = __webpack_public_path__ + "media/images/weather/105_day-35948a3e2bfea8e8c094d3880fd2cc93.png";